import { useSelector } from "react-redux";
import { hasPermission } from "../authUtils";

/**
 * @param {string|string[]} requiredPermissions - Required permission(s)
 * @param {'AND'|'OR'} logic - Logic to apply if multiple permissions are passed
 * @returns {boolean}
 */
export const useHasPermission = (requiredPermissions, logic = "OR") => {
  const { permissions: userPermissions } = useSelector((state) => state.user);

  return hasPermission(requiredPermissions, userPermissions, logic);
};
